var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0859 22.4121C20.0859 34.7708 30.1393 44.8242 42.498 44.8242C54.8567 44.8242 64.9102 34.7708 64.9102 22.4121C64.9102 10.0534 54.8567 0 42.498 0C30.1393 0 20.0859 10.0534 20.0859 22.4121Z",
    fill: "#7CC4FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9121 22.4121C64.9121 10.0534 54.8587 0 42.5 0V44.8242C54.8587 44.8242 64.9121 34.7708 64.9121 22.4121Z",
    fill: "#47A3F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14844 82.5098C5.14844 83.8862 6.26224 85 7.63867 85H77.3652C78.7417 85 79.8555 83.8862 79.8555 82.5098C79.8555 64.6598 65.3324 49.8047 47.4824 49.8047H37.5215C19.6715 49.8047 5.14844 64.6598 5.14844 82.5098Z",
    fill: "#7CC4FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4805 49.8047H42.5V85H77.3633C78.7397 85 79.8535 83.8862 79.8535 82.5098C79.8535 64.6598 65.3305 49.8047 47.4805 49.8047Z",
    fill: "#47A3F3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlone);
export default __webpack_public_path__ + "static/media/alone.9a6e3100e6c7da42cca0e4c9dc230c1c.svg";
export { ForwardRef as ReactComponent };